import React from "react";
import CheckUnckeck from "../../../utility/templete/checkUnckeck";
import direction from "../../../service/direction.json";
const Possibilities = () => {
  return (
    <div>
      <div class="card text-center">
        <div class="card-header text-bold" style={{ fontSize: "40px" }}>
          آیا می خواهید از طریق فروش پنل اس ام اس کسب درآمد کنید؟
        </div>
        <div className="card-body">
          <h5 className="card-title">
            نمایندگی مستقل فروش پنل اس ام اس بگیرید و با کمترین سرمایه اولیه
            بیشترین درآمد را کسب کنید
          </h5>
          <p className="card-text">
            <div className="form-group row col-md-12 text-justify">
              <div className="col-md-6 text-bold">
                <br />
                <br />
                <br />
                <br />
                <CheckUnckeck
                  value={1}
                  title="ایجاد کاربر (پنل) به تعداد نامحدود بدون پرداخت هزینه"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="فعال کردن تمام ماژول ها و امکانات سامانه برای کاربران بدون پرداخت هزینه"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="خط اختصاصی انتخابی رایگان برای هر کاربر جدید ایجاد شده"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="فعالیت با نام تجاری و برند و لوگوی اختصاصی نماینده"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="تعریف یک دامنه یا زیردامنه ی اختصاصی برای ورود کاربران"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="فروش پنل و خطوط اختصاصی و اعتبار پیامک به کاربران با مبلغ دلخواه"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="امکان ارائه کمترین تعرفه کشور، 95 ریال برای هر پیامک فارسی"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="پنل نمایندگی پیامک دائمی و بدون نیاز به تمدید سالانه"
                />
                <p />
                <CheckUnckeck
                  value={1}
                  title="نمایندگی مشابه اعطا کنید و زیرمجموعه های خود را افزایش دهید"
                />
              </div>
              <div className="col-md-6 text-center">
                <img
                  src={`${direction.ImgDesign}reseller.png`}
                  alt="سایه بان"
                />
              </div>
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Possibilities;
